module.exports = __webpack_public_path__ + "img/mp-table-closeup.94c218ae.jpg";